import { createImmutableMap } from 'ctm-util-functions';

/**
 * The Read Only reducer
 * @param  {Object} initialState - The initial state.
 * @returns {Object}              - The new state.
 */
export const createReadOnlyReducer = (initialState = {}) => {
    const immutableInitialState = createImmutableMap(initialState);
    return (state = immutableInitialState, action) => {
        // empty for now as this is currently read-only state
        return state;
    };
};
